import { useMutation } from '@tanstack/react-query';
import { createAuthSession, CreateAuthSessionParams } from '../../services/backendService';

export const useCreateAuthSession = () => {
  return useMutation({
    mutationKey: ['authSession'],
    mutationFn: (params: CreateAuthSessionParams) => createAuthSession(params),
  });
};
